export const SET_WORKSPACE_COMPANY = 'SET_WORKSPACE_COMPANY';

export const FETCH_PENDING_MEMOS_REQUEST = 'FETCH_PENDING_MEMOS_REQUEST';
export const FETCH_PENDING_MEMOS_SUCCESS = 'FETCH_PENDING_MEMOS_SUCCESS';
export const FETCH_PENDING_MEMOS_FAIL = 'FETCH_PENDING_MEMOS_FAIL';

export const FETCH_ACCOUNT_NETWORK_INVITATIONS_REQUEST = 'FETCH_ACCOUNT_NETWORK_INVITATIONS_REQUEST';
export const FETCH_ACCOUNT_NETWORK_INVITATIONS_SUCCESS = 'FETCH_ACCOUNT_NETWORK_INVITATIONS_SUCCESS';
export const FETCH_ACCOUNT_NETWORK_INVITATIONS_FAIL = 'FETCH_ACCOUNT_NETWORK_INVITATIONS_FAIL';
